import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Restaura la posición del scroll al navegar:
 * - Si la URL tiene un hash (#seccion), desplaza suavemente hasta esa
 *   sección del producto/documento (su "sección correspondiente").
 * - Si no, lleva el scroll al inicio, donde comienza el contenido
 *   del producto (ver detalle, páginas de tienda, etc.).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Darle tiempo al render del contenido de la ruta destino
      const targetId = hash.replace('#', '');
      const timer = window.setTimeout(() => {
        const target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        window.scrollTo(0, 0);
      }, 100);
      return () => window.clearTimeout(timer);
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}